(function () {
  'use strict';

  var instances = new WeakMap();

  function initTrack(root) {
    if (!root || instances.has(root)) return;

    var track = root.querySelector('[data-product-carousel-scroller]');
    if (!track) return;

    var prevButton = root.querySelector('[data-carousel-prev]');
    var nextButton = root.querySelector('[data-carousel-next]');

    var state = {
      isDown: false,
      startX: 0,
      scrollStart: 0,
      moved: false
    };

    function getStep() {
      var card = track.querySelector(':scope > .card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrowState() {
      if (!prevButton && !nextButton) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevButton) prevButton.disabled = track.scrollLeft <= 1;
      if (nextButton) nextButton.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function onPrevClick() {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    }

    function onNextClick() {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    }

    // Pointer-based drag to scroll (mouse + touch unified)
    function onPointerDown(e) {
      state.isDown = true;
      state.moved = false;
      state.startX = e.pageX || (e.touches && e.touches[0].pageX) || 0;
      state.scrollStart = track.scrollLeft;
      track.setAttribute('data-dragging', 'true');
    }

    function onPointerMove(e) {
      if (!state.isDown) return;
      var x = e.pageX || (e.touches && e.touches[0].pageX) || 0;
      var delta = x - state.startX;
      if (Math.abs(delta) > 3) state.moved = true;
      track.scrollLeft = state.scrollStart - delta;
    }

    function onPointerUp() {
      if (!state.isDown) return;
      state.isDown = false;
      track.removeAttribute('data-dragging');
    }

    function onClickCapture(e) {
      if (state.moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    function onScroll() {
      window.requestAnimationFrame(updateArrowState);
    }

    track.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);
    track.addEventListener('touchstart', onPointerDown, { passive: true });
    track.addEventListener('touchmove', onPointerMove, { passive: true });
    track.addEventListener('touchend', onPointerUp);
    track.addEventListener('click', onClickCapture, true);
    track.addEventListener('scroll', onScroll, { passive: true });

    if (prevButton) prevButton.addEventListener('click', onPrevClick);
    if (nextButton) nextButton.addEventListener('click', onNextClick);

    updateArrowState();

    instances.set(root, {
      destroy: function () {
        track.removeEventListener('mousedown', onPointerDown);
        window.removeEventListener('mousemove', onPointerMove);
        window.removeEventListener('mouseup', onPointerUp);
        track.removeEventListener('touchstart', onPointerDown);
        track.removeEventListener('touchmove', onPointerMove);
        track.removeEventListener('touchend', onPointerUp);
        track.removeEventListener('click', onClickCapture, true);
        track.removeEventListener('scroll', onScroll);
        if (prevButton) prevButton.removeEventListener('click', onPrevClick);
        if (nextButton) nextButton.removeEventListener('click', onNextClick);
      }
    });
  }

  function destroyTrack(root) {
    var instance = instances.get(root);
    if (instance) {
      instance.destroy();
      instances.delete(root);
    }
  }

  function initAll(scope) {
    var scopeEl = scope || document;
    scopeEl.querySelectorAll('[data-product-carousel-track]').forEach(initTrack);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Theme editor support: re-init on section load, tear down on unload.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-carousel-track]');
    if (root) initTrack(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-product-carousel-track]');
    if (root) destroyTrack(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target;
    if (!card || !card.hasAttribute('data-carousel-card')) return;
    var track = card.closest('[data-product-carousel-scroller]');
    if (!track) return;
    card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  });

  // Already initialized if this script executes after DOMContentLoaded (e.g. re-inserted section).
  if (document.readyState !== 'loading') {
    initAll(document);
  }
})();
